export const orderRequestConstants = {
  // Toggled Buy-Sell Modals.
  TOGGLED_ORDER_FUNDS_REQUEST_MODAL: 'TOGGLED_ORDER_FUNDS_REQUEST_MODAL',
  CLEAR_ERROR_MESSAGE: 'CLEAR_ERROR_MESSAGE',

  // Updated Active Tab (buy, sell, switch).
  UPDATE_ACTIVE_TAB_ORDER_FUNDS_REQUEST_MODAL: 'UPDATE_ACTIVE_TAB_ORDER_FUNDS_REQUEST_MODAL',

  // Updated Fund Id to order request.
  UPDATE_NAVIGATION_FUND_TO_ORDER_REQUEST_MODAL: 'UPDATE_NAVIGATION_FUND_TO_ORDER_REQUEST_MODAL',
  CLEAR_NAVIGATION_FUND_TO_ORDER_REQUEST_MODAL: 'CLEAR_NAVIGATION_FUND_TO_ORDER_REQUEST_MODAL',
  
  // Get Fund Information (Buy, Sell).
  FETCH_BUY_FUND_INFO_START: 'FETCH_BUY_FUND_INFO_START',
  FETCH_SELL_FUND_INFO_START: 'FETCH_SELL_FUND_INFO_START',
  UPDATE_FUND_INFO: 'UPDATE_FUND_INFO',
  CLEAR_FUND_INFO: 'CLEAR_FUND_INFO',

  // Fund Information 2 (Switch).
  FETCH_SWITCH_FUND_INFO_START: 'FETCH_SWITCH_FUND_INFO_START',
  UPDATE_FUNDS_INFO_2: 'UPDATE_FUNDS_INFO_2',
  CLEAR_FUND_INFO_2: 'CLEAR_FUND_INFO_2',

  // Checked Fund able to order. (Buy, Switch)
  CLEAR_CHECKED_FUND_ABLE: 'CLEAR_CHECKED_FUND_ABLE',
  CHECKED_BUYABLE_FUND_START: 'CHECKED_BUYABLE_FUND_START',
  CHECKED_SELLABLE_FUND_START: 'CHECKED_SELLABLE_FUND_START',
  CHECKED_SWITCHABLE_FUND_START: 'CHECKED_SWITCHABLE_FUND_START',
  CHECKED_FUND_ABLE_TO_ORDER_SUCCESS: 'CHECKED_FUND_ABLE_TO_ORDER_SUCCESS',
  CHECKED_FUND_ABLE_TO_ORDER_FAILURE: 'CHECKED_FUND_ABLE_TO_ORDER_FAILURE',

  // Switch Fund
  GET_SWITCHABLE_FUNDS_START: 'GET_SWITCHABLE_FUNDS_START',
  GET_SWITCHABLE_FUNDS_SUCCESS: 'GET_SWITCHABLE_FUNDS_SUCCESS',
  GET_SWITCHABLE_FUNDS_FAILURE: 'GET_SWITCHABLE_FUNDS_FAILURE',

  // SEND_QUESTION_BACK_TO_CONFIRM
  CONFIRM_ORDER_FUND_START: 'CONFIRM_ORDER_FUND_START',
  CONFIRM_ORDER_FUND_SUCCESS: 'CONFIRM_ORDER_FUND_SUCCESS',
  CONFIRM_ORDER_FUND_FAILURE: 'CONFIRM_ORDER_FUND_FAILURE',
  
  RESET_CONFIRM_ORDER_FUND: 'RESET_CONFIRM_ORDER_FUND',

  // SEARCH FUND INFORMATION
  CLEAR_SEARCH_FUNDS_INFO: 'CLEAR_SEARCH_FUNDS_INFO',
  UPDATE_SEARCH_FUNDS_INFO: 'UPDATE_SEARCH_FUNDS_INFO',
  REMOVE_SEARCH_FUNDS_INFO: 'REMOVE_SEARCH_FUNDS_INFO',

  CLEAR_FUND_INFO_2: 'CLEAR_FUND_INFO_2',

  UPDATE_SEARCH_PORTFOLIOS: 'UPDATE_SEARCH_PORTFOLIOS',

  TOGGLE_MODAL_MESSAGE: 'TOGGLE_MODAL_MESSAGE',

  // FORM
  // GET_LATEST_PLAN: 'GET_LATEST_PLAN',
  UPDATE_LATEST_PLAN: 'UPDATE_LATEST_PLAN',
  CLEAR_LATEST_PLAN: 'CLEAR_LATEST_PLAN',
  UPDATE_LATEST_SETTLE_DATE: 'UPDATE_LATEST_SETTLE_DATE',
};
